import * as Form from '@radix-ui/react-form';
import styled from 'styled-components';

interface Props {
  fontSize?: string
}

export const InputLabel = styled(Form.Label) <Props>`
  font-weight: 700;
  font-size: ${props => props.fontSize ? props.fontSize : '14px'};
  cursor: pointer;
`;
